"use client";
import { css as i } from "@emotion/react";
const o = i`
	&:not(:focus, :active, :focus-within) {
		clip-path: inset(50%);
		height: 1px;
		overflow: hidden;
		position: absolute;
		white-space: nowrap;
		width: 1px;
	}
`;
export {
  o as visuallyHidden
};
